import React from "react";

export default function CsvFileIcon() {
  return (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6715 0H26.2167L38.1753 11.9586V34.9271C38.1753 37.7184 35.8937 40 33.1024 40H12.6715C9.88019 40 7.59863 37.7184 7.59863 34.9271V5.07289C7.59863 2.28148 9.88012 0 12.6715 0Z"
        fill="#00733B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2188 0L38.1773 11.9586H27.5081C26.7971 11.9586 26.2188 11.3802 26.2188 10.6692V0Z"
        fill="#005C2F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.93758 17.0312H29.4874C30.1001 17.0312 30.6008 17.5319 30.6008 18.1446V28.2515C30.6008 28.8641 30.1002 29.3671 29.4874 29.3671H1.93758C1.32492 29.3671 0.824219 28.8641 0.824219 28.2515V18.1446C0.824219 17.5319 1.32484 17.0312 1.93758 17.0312Z"
        fill="#005C2F"
      />
      <path
        d="M7.57297 21.8178V24.5794C7.57297 25.3691 8.21547 26.0116 9.00523 26.0116C9.79492 26.0116 10.4374 25.3691 10.4374 24.5794C10.4374 24.2227 10.7266 23.9335 11.0832 23.9335C11.4399 23.9335 11.729 24.2227 11.729 24.5794C11.729 26.0813 10.5071 27.3032 9.00516 27.3032C7.5032 27.3032 6.28125 26.0812 6.28125 24.5794V21.8178C6.28125 20.3159 7.5032 19.094 9.00516 19.094C10.5071 19.094 11.729 20.3159 11.729 21.8178C11.729 22.1745 11.4398 22.4637 11.0832 22.4637C10.7265 22.4637 10.4374 22.1745 10.4374 21.8178C10.4374 21.0281 9.79492 20.3856 9.00523 20.3856C8.21547 20.3856 7.57297 21.0281 7.57297 21.8178ZM15.2189 20.3856H16.2477C16.663 20.3856 17.0009 20.7235 17.0009 21.1389C17.0009 21.4956 17.2901 21.7847 17.6467 21.7847C18.0034 21.7847 18.2925 21.4955 18.2925 21.1389C18.2925 20.0113 17.3752 19.094 16.2476 19.094H15.2188C13.9085 19.094 12.8424 20.1591 12.8424 21.468C12.8424 22.6267 13.4377 23.1919 13.9371 23.462C14.5708 23.8048 15.37 23.8444 15.916 23.8444C16.5141 23.8444 17.0008 24.33 17.0008 24.9268C17.0008 25.5249 16.5141 26.0116 15.916 26.0116H14.8873C14.472 26.0116 14.134 25.6737 14.134 25.2583C14.134 24.9016 13.8448 24.6124 13.4882 24.6124C13.1315 24.6124 12.8424 24.9016 12.8424 25.2583C12.8424 26.3859 13.7598 27.3032 14.8873 27.3032H15.9161C17.2264 27.3032 18.2925 26.2371 18.2925 24.9268C18.2925 23.6177 17.2264 22.5527 15.9161 22.5527C14.2682 22.5527 14.1341 22.0614 14.1341 21.468C14.1341 20.8712 14.6207 20.3856 15.2189 20.3856ZM24.6995 19.1269C24.361 19.0144 23.9954 19.1977 23.883 19.5362L22.1984 24.6084L20.5138 19.5362C20.4013 19.1977 20.0359 19.0145 19.6973 19.1269C19.3588 19.2393 19.1755 19.6048 19.2879 19.9434L21.5855 26.861C21.6732 27.125 21.9201 27.3033 22.1984 27.3033C22.4766 27.3033 22.7236 27.1251 22.8113 26.861L25.1087 19.9434C25.2212 19.6048 25.038 19.2393 24.6995 19.1269Z"
        fill="white"
      />
    </svg>
  );
}
